import { Component, ViewChild, AfterViewInit, OnInit, ElementRef, TemplateRef, Input } from '@angular/core';
import { LogcatService } from '../services/logcat.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { TranslateModule } from '@ngx-translate/core';

import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-logcat-table',
  templateUrl: './logcat-table.component.html',
  styleUrls: ['./logcat-table.component.css'],
  standalone: true,
  imports: [TranslateModule, FormsModule]
})
export class LogcatTableComponent implements OnInit, AfterViewInit {
  @ViewChild('alerttemplate') alertTemplate!: TemplateRef<any>;
  @Input() filters: any;
  private rowCount: number;
  msg: string = "";
  parent: HTMLElement
  priority: any
  body: any
  autoScroll: boolean = true;
  autoScrollDependingOnScrollPosition: boolean = true;
  scrollPosition: number = 0;
  scrollHeight: number = 0;
  maxEntriesBuffer: number = 3000;
  maxVisibleEntries: number = 100;
  deviceSerial: string;
  started: any
  allowClean: any
  logdumpydata: any
  @ViewChild('parent') parentElement!: ElementRef;
  @ViewChild('SaveLogs_message') SaveLogs: TemplateRef<any>;
  modalRef!: MatDialogRef<any>;
  saveLogFileName: any
  selectedExtension: any
  logExtentension = ['json', 'log']
  samplePresentation: any
  parsedOutput: any
  device: any = []
  output: any = {}
  logdata = {}
  toSave: any


  constructor(private elementRef: ElementRef, private logcatService: LogcatService,
    private dialog: MatDialog
  ) {
    this.rowCount = 0;
  }
  ngOnInit(): void {
    this.deviceSerial = window.location.href.split('/').pop()
    this.body = this.elementRef.nativeElement.querySelector('tbody')
    this.logcatService.logdata.subscribe(data => {

      this.addEntryListener(data)
      this.device.push(data)

    })



    this.selectedExtension = this.logExtentension[0]

  }
  ngAfterViewInit(): void {
    if (!this.parent && this.parentElement) {
      this.parent = this.parentElement.nativeElement;
    }
  }
  checkAllowClean() {
    if (Object.keys(this.logcatService.deviceEntries).includes(this.deviceSerial)) {
      return this.logcatService.deviceEntries[this.deviceSerial].allowClean
    }
    return false
  }

  checkLoggerServiceStatus(loadLogs = false) {
    let collectedLogs = []

    let isStarted = false
    // if (Object.keys($rootScope).includes('LogcatService')) {
    //   this.logcatService.deviceEntries = $rootScope.LogcatService.deviceEntries
    // }
    // if ('LogcatService' in this.logcatService) {
    //   this.logcatService.deviceEntries = this.logcatService.LogcatService.deviceEntries;
    if (Object.keys(this.logcatService.deviceEntries).includes(this.deviceSerial)) {
      collectedLogs = this.logcatService.deviceEntries[this.deviceSerial].logs
      isStarted = this.logcatService.deviceEntries[this.deviceSerial].started
    }
    if (loadLogs) {
      this.restoreLogs(collectedLogs)
    }
    return isStarted

  }
  limitVisibleEntries() {
    let limiter
    if (this.maxVisibleEntries > this.maxEntriesBuffer) {
      limiter = this.maxEntriesBuffer
    } else {
      limiter = this.maxVisibleEntries
    }
    // if (element.find('tbody')[0].rows.length > limiter) {
    //   removeFirstLogTableEntry()
    // }
    if (this.elementRef.nativeElement.querySelector('tbody')[0].rows.length > limiter) {
      this.removeFirstLogTableEntry()
    }
  }
  removeFirstLogTableEntry() {
    // element.find('tbody')[0].deleteRow(0)
    this.elementRef.nativeElement.querySelector('tbody')[0].deleteRow(0)

  }
  // LogcatService.addEntryListener = function(entry) {
  //   if (deviceSerial === entry.serial) {
  //     limitVisibleEntries()
  //     if (LogcatService.deviceEntries[deviceSerial].logs.length > maxEntriesBuffer) {
  //       LogcatService.deviceEntries[deviceSerial].logs.shift()
  //     }
  //     addRow(body, entry)
  //   }
  // }


  // this.logcatService.addEntryListener(entr)
  //   restoreLogs(collectedLogs: any) {
  //   }
  // LogcatService.addFilteredEntriesListener = function(entries) {
  //   checkLoggerServiceStatus()
  // }
  shouldAutoScroll() {
    if (this.autoScrollDependingOnScrollPosition) {
      return this.scrollPosition === this.scrollHeight
    } else {
      return true
    }
  }
  scrollListener(event) {
    this.scrollPosition = event.target.scrollTop + event.target.clientHeight
    this.scrollHeight = event.target.scrollHeight
  }

  // let throttledScrollListener = _.throttle(scrollListener, 100)
  // parent.addEventListener('scroll', throttledScrollListener, false)
  scrollToBottom() {
    this.parent.scrollTop = this.parent.scrollHeight + 20
    // $timeout(function() {
    //   parent.scrollTop = parent.scrollHeight
    // }, 10)
  }
  addEntryListener(entry: any) {


    if (this.deviceSerial === entry.serial) {
      //  this.limitVisibleEntries()
      if (this.logcatService.deviceEntries[this.deviceSerial].logs.length > this.maxEntriesBuffer) {
        this.logcatService.deviceEntries[this.deviceSerial].logs.shift()
      }
      this.addRow(this.body, entry)
    }
  }


  addRow(rowParent, data) {


    let newRow = rowParent.insertRow(-1);

    // Assign color based on priority level
    let colorScheme = {
      'Verbose': 'blueviolet',
      'Debug': '#020c7d',
      'Info': '#177d1c',
      'Warn': 'coral',
      'Error': 'red',
      'Fatal': 'darkcyan'
    };
    let rowColor = colorScheme[data.priorityLabel];

    // Function to create a cell with a smaller font size and specific color
    function createStyledCell(text, isFirstRow = false, isFirstColumn = false) {
      let cell = newRow.insertCell(-1);
      cell.style.fontSize = '0.8rem';
      cell.style.color = rowColor;
      cell.style.textAlign = 'center';
      cell.appendChild(document.createTextNode(text));

      if (isFirstColumn) {
        cell.style.width = '15%';
      } else {
        cell.style.width = '50%';
      }

      return cell;
    }

    // Create cells with font-size and color
    createStyledCell(data.priorityLabel, this.rowCount === 0, true); // First column
    createStyledCell(data.message, this.rowCount === 0, false);
    createStyledCell(data.dateLabel, this.rowCount === 0, false);

    // if ($rootScope.platform === 'native') {
    //   createStyledCell(data.pid, this.rowCount === 0, false);
    //   createStyledCell(data.tid, this.rowCount === 0, false);
    // }

    createStyledCell(data.tag, this.rowCount === 0, false); // First column

    // Alternate row background color
    newRow.style.backgroundColor = (this.rowCount % 2 === 0) ? '#eaf3fc' : '#F5F7F8';
    this.rowCount++; // Increment the counter

    // if (autoScroll && shouldAutoScroll() && !batchRequest) {
    //   _.throttle(scrollToBottom, 30)();
    // }


  }




  ///:::::::::::::::::::::::?????????????????????????????????????????????????????????????????????????
  //  addRow(rowParent, data, batchRequest) {
  //   let newRow = rowParent.insertRow(-1)
  //   newRow.classList.add('log-' + data.priorityLabel)
  //   newRow.insertCell(-1)
  //     .appendChild(document.createTextNode(data.priorityLabel))
  //   newRow.insertCell(-1)
  //     .appendChild(document.createTextNode(data.dateLabel))
  //   if ($rootScope.platform === 'native') {
  //     newRow.insertCell(-1)
  //       .appendChild(document.createTextNode(data.pid))
  //     newRow.insertCell(-1)
  //       .appendChild(document.createTextNode(data.tid))
  //     newRow.insertCell(-1)
  //       .appendChild(document.createTextNode(data.tag))
  //   }
  //   newRow.insertCell(-1)
  //     .appendChild(document.createTextNode(data.message))
  //   if (autoScroll && shouldAutoScroll() && !batchRequest) {
  //     _.throttle(scrollToBottom, 30)()
  //   }
  // }


  clearTable() {
    let oldBody = this.body
    let newBody = document.createElement('tbody')
    oldBody.parentNode.replaceChild(newBody, oldBody)
    this.body = newBody
  }

  restoreLogs(collectedLogs) {
    this.clearTable()
    let startFrom = 0
    if (collectedLogs.length - this.maxVisibleEntries >= 0) {
      startFrom = collectedLogs.length - this.maxVisibleEntries
    }
    // for (let logLine = startFrom; logLine < collectedLogs.length; logLine++) {
    //   if (this.deviceSerial === collectedLogs[logLine].serial) {
    //    this. addRow(this.body, collectedLogs[logLine], true)
    //   }
    // }
  }
  /**
     * Validate filter.data object value and assign bordercolor to red if value
     * doesn't match regex(pattern):
     * - HH:mm:ss.SSS
     * - H:mm:ss.SSS
     * - :mm:SS.SSS
     * - mm:ss.SSS
     * - m:ss.SSS
     * -... combinations
     *  in other case colour will be set to default.
     *
    
    //  */
  // scope.validateDate = function(e) {
  //   let pattern = ['^(?:(?:([0-1]?\\d|2[0-3]):)?(:[0-5]\\d|[0-5]\\d):|\\d)',
  //     '?(:[0-5]\\d|[0-5]\\d{1,2})?(\\.[0-9]?\\d{0,2}|:[0-5]?\\d{0,1})|(\\d{0,2})'].join([])
  //   let regex = new RegExp(pattern, 'g')
  //   let inputValue = event.srcElement.value
  //   let matchArray = inputValue.match(regex)
  //   let isTextValid = false
  //   if (matchArray) {
  //     matchArray.forEach(function(item, index) {
  //       if (item === inputValue) {
  //         isTextValid = true
  //         event.srcElement.style.borderColor = ''
  //       }
  //     })
  //   }
  //   if (isTextValid === false) {
  //     event.srcElement.style.borderColor = 'red'
  //   }
  // }
  /**
   * Show "Save Log" modal.
   *
   */
  // scope.saveLogs = function() {
  //   let collectedLogs = []
  //   if (Object.keys(LogcatService.deviceEntries).includes(deviceSerial)) {
  //     collectedLogs = LogcatService.deviceEntries[deviceSerial].logs
  //   }
  //   SaveLogService.open(collectedLogs, false)
  // }
  // scope.$on('$destroy', function() {
  //   parent.removeEventListener('scroll', throttledScrollListener)
  // })
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>   template model 


  showsaveLogs() {
    this.modalRef = this.dialog.open(this.SaveLogs)
    this.createSamplePresentation(this.device, this.selectedExtension, this.filters.priority);
  }
  clear() {
    this.logcatService.clear()
    this.clearTable()
  }
  logtype(event: any) {
    this.selectedExtension = event.target.value
    this.createSamplePresentation(this.device, this.selectedExtension)
  }
  filterLogsByPriority(deviceLogs, priorityLabel) {
    if (priorityLabel == "Default") {
      return deviceLogs; // Return all logs if priorityLabel is undefined
    }
    return deviceLogs.filter(log => log.priorityLabel === priorityLabel);
  }

  parseLogsToDefinedExtenstion(devicename: any, logExtension: any, priorityLabel?: any, lineLimitation?: any) {
    let lineLimiter = isNaN(lineLimitation) ? devicename.length : lineLimitation;


    const filteredLogs = this.filterLogsByPriority(devicename, priorityLabel);


    if (filteredLogs.length > 0) {
      if (logExtension === 'log') {
        this.output = "";
        for (let line = 0; line < Math.min(lineLimiter, filteredLogs.length); line++) {
          this.output += [filteredLogs[line].dateLabel, filteredLogs[line].pid,
          filteredLogs[line].tag, filteredLogs[line].priorityLabel,
          filteredLogs[line].message].join('\t') + '\n';
        }
      } else {
        this.output = {
          'deviceOS': filteredLogs[0].deviceLabel,
          'serial': filteredLogs[0].serial,
          'logs': []
        };

        for (let line = 0; line < Math.min(lineLimiter, filteredLogs.length); line++) {
          this.logdata = {
            'date': filteredLogs[line].dateLabel,
            'pid': filteredLogs[line].pid,
            'tag': filteredLogs[line].tag,
            'priorityLabel': filteredLogs[line].priorityLabel,
            'message': filteredLogs[line].message
          };
          this.output.logs.push(this.logdata);
        }
      }
    }
    return this.output;
  }
  cancel() {
    this.modalRef.close()
  }

  saveLogs() {
    if (this.samplePresentation === "{}") {
      this.msg = "Without generation of log we cannot download log files";
      this.openAlertMod(this.alertTemplate, this.msg);
      return;
    }

    if (this.samplePresentation !== "{}") {
      switch (this.selectedExtension) {
        case 'json':
          this.parsedOutput = new Blob(
            [JSON.stringify(this.parseLogsToDefinedExtenstion(this.device, this.selectedExtension, this.priority))],
            { type: 'application/json;charset=utf-8' }
          );
          break;
        case 'xlsx':
          this.parsedOutput = new Blob(
            [this.convertToExcel(this.parseLogsToDefinedExtenstion(this.device, this.selectedExtension, this.priority))],
            { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
          );
          break;
        default:
          this.msg = "Unsupported format";
          this.openAlertMod(this.alertTemplate, this.msg);
          return;
      }

      const fileName = this.saveLogFileName ? this.saveLogFileName : (window.location.href).split('/').pop();
      FileSaver.saveAs(this.parsedOutput, fileName + '.' + this.selectedExtension);
    }
  }
  convertToExcel(jsonData: any) {
    // Structure the logs as an array of objects, where each object represents a row in the table
    const logsInTabularFormat = jsonData.logs.map((log: any) => ({
      date: log.date,
      pid: log.pid,
      tag: log.tag,
      priorityLabel: log.priorityLabel,
      message: log.message
    }));


    const ws = XLSX.utils.json_to_sheet(logsInTabularFormat);

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Logs");

    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });

    return excelBuffer;
  }


  JcreatePlainText(jsonString) {

    const data = JSON.parse(jsonString);


    let plainText = "";


    for (let key in data) {

      if (Array.isArray(data[key])) {
        plainText += `${key}:\n`;


        data[key].forEach((item, index) => {
          plainText += `  Log ${index + 1}:\n`;
          for (let logKey in item) {
            plainText += `    ${logKey}: ${item[logKey]}\n`;
          }
        });
      } else {
        plainText += `${key}: ${data[key]}\n`;
      }
    }

    return plainText;
  }

  createSamplePresentation(device: any, logExtension: any, priority?: any) {
    this.priority = priority.name;
    this.toSave = this.parseLogsToDefinedExtenstion(device, logExtension, priority.name, 4);

    if (this.toSave.length > 0 || typeof this.toSave === 'object') {
      switch (logExtension) {
        case 'json':
          this.samplePresentation = JSON.stringify(this.toSave);
          break;
        case 'xlsx':
          this.samplePresentation = this.JcreatePlainText(JSON.stringify(this.toSave));
          break;
        default:
          this.samplePresentation = this.toSave;
          break;
      }
    }
  }



  openAlertMod(template: TemplateRef<any>, message: any) {
    this.modalRef = this.dialog.open(template, { width: '300px' });
    this.msg = message;
    setTimeout(() => {
      this.modalRef.close();;
      this.msg = "";
    }, 2000)
  }

  Ok() {
    this.modalRef.close();;
    this.msg = "";
  }

}